<script setup>
import {ref, onMounted} from 'vue';

const show = ref(false);

onMounted(() => {
	show.value = true;
});

</script>

<template>
	<div class="itModal">

		<transition name="fade-y">

			<div class="contents position-relative" v-if="show">

				<div class="header position-relative d-flex justify-content-between align-items-center">
					<span class="font-medium post-title font-semibold">
						<slot name="header"></slot>
					</span>
					<i class="lnr icon-cross cursor-pointer p-1" @click="$emit('hide')"></i>
				</div>

				<hr>

				<slot></slot>

			</div>
		</transition>

	</div>
</template>

<script>
export default {
	name: "Modal",
}
</script>

<style scoped>

</style>